<div class="modal-content">
  <div class="modal-body">
    <button
      aria-label="Close"
      class="close"
      type="button"
      (click)="anuluj()"
    ></button>

    <div class="ft__01 text-center py-4">Dodaj godziny pracy</div>

    <!-- Formularz główny -->
    <form *ngIf="!czyPokazacPotwierdzenie">
      <!-- Pracownik -->
      <div class="input_container pb-3">
        <label class="label-field">Pracownik</label>
        <ng-select
          [searchable]="true"
          [clearable]="false"
          [multiple]="false"
          [items]="pracownicy"
          [clear]
          [(ngModel)]="wybranyPracownikId"
          bindLabel="nazwa"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          notFoundText="Brak pracowników"
        >
        </ng-select>
      </div>

      <!-- Projekt -->
      <div class="input_container pb-3">
        <label class="label-field">Projekt</label>
        <ng-select
          [searchable]="true"
          [clearable]="false"
          [multiple]="false"
          [items]="projekty"
          [(ngModel)]="wybranyProjektId"
          bindLabel="nazwa"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          notFoundText="Brak projektów"
        >
        </ng-select>
      </div>

      <!-- Data -->
      <div class="input_container pb-3">
        <label class="label-field">Data</label>
        <input
          type="date"
          [(ngModel)]="data"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>

      <!-- Liczba godzin -->
      <div class="input_container pb-3">
        <label class="label-field">Liczba godzin</label>
        <input
          type="number"
          [(ngModel)]="godziny"
          [ngModelOptions]="{ standalone: true }"
          min="0"
          max="24"
          step="0.5"
          placeholder="8"
        />
      </div>

      <!-- Przyciski -->
      <div class="input_container pb-3 mt-4">
        <button class="btn__primary" type="button" (click)="zapisz()">
          Zapisz
        </button>
      </div>
      <div class="input_container pb-3">
        <button class="btn__link" type="button" (click)="anuluj()">
          Anuluj
        </button>
      </div>
    </form>

    <!-- Komunikat potwierdzenia -->
    <div *ngIf="czyPokazacPotwierdzenie" class="text-center">
      <div class="pb-4">
        <p>Wpis dla tego pracownika i tej daty już istnieje.</p>
        <p><strong>Czy na pewno chcesz go nadpisać?</strong></p>
      </div>

      <div class="input_container pb-3">
        <button class="btn__primary" type="button" (click)="zapisz()">
          Tak, nadpisz
        </button>
      </div>
      <div class="input_container pb-3">
        <button class="btn__link" type="button" (click)="anulujPotwierdzenie()">
          Nie, wróć
        </button>
      </div>
    </div>
  </div>
</div>
